// Multivariate Dependencies
import React from 'react';
// Components
import { Label } from '../../Label';
export var RadioStructure = function (_a) {
    var disabled = _a.disabled, checked = _a.checked, value = _a.value, onChange = _a.onChange, className = _a.className, label = _a.label, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    return (React.createElement(Label, { className: className, size: 'medium', "aria-label": label },
        React.createElement("input", { type: 'radio', disabled: disabled, value: value, checked: checked, onChange: onChange, readOnly: readOnly }),
        label));
};
//# sourceMappingURL=RadioStructure.js.map